import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import ServiceDetail from "./pages/ServiceDetail";
import IndustryDetail from "./pages/IndustryDetail";
import SAPDetail from "./pages/SAPDetail";
import WorkdayDetail from "./pages/WorkdayDetail";
import SalesforceDetail from "./pages/SalesforceDetail";
import MicrosoftDynamicsDetail from "./pages/MicrosoftDynamicsDetail";
import CloudPlatformsDetail from "./pages/CloudPlatformsDetail";
import UKGDetail from "./pages/UKGDetail";
import AnalyticsDetail from "./pages/AnalyticsDetail";
import KinaxisDetail from "./pages/KinaxisDetail";
import MuleSoftDetail from "./pages/MuleSoftDetail";
import SAPEndToEndDetail from "./pages/SAPEndToEndDetail";
import SAPS4HANADetail from "./pages/SAPS4HANADetail";
import RiseWithSAPDetail from "./pages/RiseWithSAPDetail";
import SAPS4HANARiseDetail from "./pages/SAPS4HANARiseDetail";
import About from "./pages/About";
import CaseStudiesPage from "./pages/CaseStudiesPage";
import ODCPage from "./pages/ODCPage";
import ContactPage from "./pages/ContactPage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import CookiePolicy from "./pages/CookiePolicy";
import NotFound from "./pages/NotFound";
import ScrollToHashElement from "./ScrollToHashElement";
import AllServices from "./pages/AllServices";
import PayrollDetail from "./pages/PayrollDetail";
import CommunicationToolDetails from "./pages/GroupNotification";
import WorkforceManagement from "./pages/WorkforceManagement";
import SolutionDetail from "./pages/SolutionsDetails";
import ModernHiring from "./pages/ModernHiering";
import EndToEndEnterprise from "./pages/EndToEndEnterprise";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <ScrollToHashElement />
        {/* <Toaster richColors position="top-right" /> */}
        <Routes>
          <Route path="/" element={<Index />} />

          {/* Service Routes */}
          <Route path="/services/:serviceId" element={<ServiceDetail />} />

          {/* Solutions Routes */}
          <Route path="/solutions/:solutionId" element={<SolutionDetail />} />

          {/* Industry Routes */}
          <Route path="/industries/:industryId" element={<IndustryDetail />} />

          {/* SAP Routes */}
          <Route path="/sap/:moduleId" element={<SAPDetail />} />

          {/* Workday Routes */}
          <Route path="/workday/:moduleId" element={<WorkdayDetail />} />

          {/* Salesforce Routes */}
          <Route path="/salesforce/:moduleId" element={<SalesforceDetail />} />

          <Route
            path="/end-to-end/:serviceId"
            element={<EndToEndEnterprise />}
          />

          {/* New Enterprise Platform Routes */}
          <Route
            path="/microsoft-dynamics-detail"
            element={<MicrosoftDynamicsDetail />}
          />
          <Route
            path="/cloud-platforms-detail"
            element={<CloudPlatformsDetail />}
          />
          <Route path="/ukg-detail" element={<UKGDetail />} />
          <Route path="/analytics-detail" element={<AnalyticsDetail />} />

          {/* Kinaxis & MuleSoft Routes */}
          <Route path="/kinaxis" element={<KinaxisDetail />} />
          <Route path="/kinaxis/:moduleId" element={<KinaxisDetail />} />
          <Route path="/mulesoft" element={<MuleSoftDetail />} />
          <Route path="/mulesoft/:moduleId" element={<MuleSoftDetail />} />

          {/* SAP End-to-End Solutions Route */}
          <Route path="/sap-end-to-end" element={<SAPEndToEndDetail />} />

          {/* SAP S/4HANA & RISE Routes */}
          <Route path="/sap-s4hana" element={<SAPS4HANADetail />} />
          <Route path="/rise-with-sap" element={<RiseWithSAPDetail />} />
          <Route path="/sap-s4hana-rise" element={<SAPS4HANARiseDetail />} />

          {/* All Services Route */}
          <Route path="/services/all" element={<AllServices />} />

          {/* Products Routes */}
          {/* <Route path="/products/payroll" element={<PayrollDetail />} /> */}

          {/* Communication Tool */}
          <Route
            path="/products/CommunicationTool"
            element={<CommunicationToolDetails />}
          />

          {/* Modern Hiring */}
          <Route path="/products/ModernHiring" element={<ModernHiring />} />

          {/* Workeforce Management */}
          <Route path="/products/Payroll" element={<WorkforceManagement />} />

          {/* Main Pages */}
          <Route path="/about" element={<About />} />
          <Route path="/case-studies" element={<CaseStudiesPage />} />
          <Route path="/odc" element={<ODCPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />

          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
